import * as React from "react";

import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

import AgentIcon from "@material-ui/icons/Search";
import InboxIcon from "@material-ui/icons/Inbox";
import AlbumIcon from "@material-ui/icons/Album";
import LibraryMusicIcon from "@material-ui/icons/LibraryMusic";
import MoneyIcon from "@material-ui/icons/AccountBalance";
import UserIcon from "@material-ui/icons/People";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import ShortTextIcon from "@material-ui/icons/ShortText";

import { routes } from "../../routes";
import { BackofficeUserTier } from "../../../../../services/release-admin/types/backoffice-user-tier";

interface AppMenuProps {
  isOpen: boolean;
  tier?: BackofficeUserTier;
  onClose: () => void;
}

export const AppMenu: React.FC<AppMenuProps> = (props) => {
  return (
    <Drawer anchor="left" open={props.isOpen} onClose={props.onClose}>
      <List>
        <ListItem button component="a" href={routes.inbox.list}>
          <ListItemIcon>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Inbox
              </Typography>
            }
          />
        </ListItem>
        {["tier-3", "tier-2", "tier-0"].includes(props.tier as string) ? (
          <ListItem button component="a" href={routes.inbox.agentView}>
            <ListItemIcon>
              <AgentIcon />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="button" display="block">
                  Agent View
                </Typography>
              }
            />
          </ListItem>
        ) : null}

        <ListItem button component="a" href={routes.releases.list}>
          <ListItemIcon>
            <AlbumIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Releases
              </Typography>
            }
          />
        </ListItem>

        <ListItem button component="a" href={routes.tracks.list}>
          <ListItemIcon>
            <LibraryMusicIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Tracks
              </Typography>
            }
          />
        </ListItem>

        <ListItem button component="a" href={routes.users.list}>
          <ListItemIcon>
            <UserIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Users
              </Typography>
            }
          />
        </ListItem>

        <ListItem button component="a" href={routes.artist.list}>
          <ListItemIcon>
            <MusicNoteIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Artists
              </Typography>
            }
          />
        </ListItem>

        <ListItem button component="a" href={routes.earnings.list}>
          <ListItemIcon>
            <MoneyIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Earnings
              </Typography>
            }
          />
        </ListItem>

        <ListItem button component="a" href={routes.syncLicense.syncBriefs}>
          <ListItemIcon>
            <ShortTextIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Sync Briefs
              </Typography>
            }
          />
        </ListItem>

        <ListItem button component="a" href={routes.macros.list}>
          <ListItemIcon>
            <ShortTextIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="button" display="block">
                Macros
              </Typography>
            }
          />
        </ListItem>
      </List>
    </Drawer>
  );
};
